'use strict';

var slicedToArray = require('../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');
require('prop-types');
var withGoogleMapsAPI = require('../../utils/withGoogleMapsAPI.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var PropertyDataView = require('./PropertyDataView.js');
var ZillowDataView = require('./ZillowDataView.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    streetView: {
      position: 'relative',
      zIndex: 2,
      '& .gmnoprint': {
        display: 'none !important'
      },
      '& .gm-style-cc': {
        display: 'none !important'
      }
    },
    propertyData: {
      top: 8,
      left: 16,
      bottom: 8,
      height: 'calc(100% - 60px)',
      position: 'absolute',
      zIndex: 3
    },
    blankData: {
      color: theme.palette.white.primary,
      zIndex: 5,
      position: 'absolute',
      top: 'calc(50% - 15px)',
      left: 'calc(50% - 80px)'
    },
    noStreetView: {
      color: theme.palette.white.primary,
      zIndex: 5,
      position: 'absolute',
      bottom: '5px',
      right: '5px'
    }
  };
};

var getStreetView = function getStreetView(latitude, longitude, streetViewRef, setShowMap, fullscreenControl) {
  var addressLocation = new google.maps.LatLng(parseFloat(latitude), parseFloat(longitude));
  var streetViewMaxDistance = 50;
  var streetViewService = new google.maps.StreetViewService();
  var panorama = new google.maps.StreetViewPanorama(streetViewRef.current, {
    position: addressLocation,
    zoom: 2,
    addressControl: false,
    linksControl: false,
    panControl: false,
    mapTypeControl: false,
    enableCloseButton: false,
    fullscreenControl: fullscreenControl,
    motionTracking: false,
    motionTrackingControl: false,
    draggable: false,
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    clickToGo: false,
    disableDefaultUI: false,
    streetViewControl: false
  });
  streetViewService.getPanoramaByLocation(panorama.getPosition(), streetViewMaxDistance, function (panoData) {
    if (panoData !== null && panoData.location !== null) {
      setShowMap(true);
      var panoCenter = panoData.location.latLng;
      var heading = google.maps.geometry.spherical.computeHeading(panoCenter, addressLocation);
      var pov = panorama.getPov();
      pov.heading = heading;
      panorama.setPov(pov);
    } else {
      setShowMap(false);
    }
  });
};

var GoogleStreetView = function GoogleStreetView(_ref) {
  var classes = _ref.classes,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      zillowData = _ref.zillowData,
      propertyData = _ref.propertyData,
      height = _ref.height,
      width = _ref.width,
      fullscreenControl = _ref.fullscreenControl;
  var streetViewRef = React.useRef(null);

  var _useState = React.useState(true),
      _useState2 = slicedToArray(_useState, 2),
      showMap = _useState2[0],
      setShowMap = _useState2[1];

  var blankData = ObjectHelper.isBlank(propertyData) && ObjectHelper.isBlank(zillowData) && !showMap;
  var showFullscreenControl = showMap && fullscreenControl;
  React.useEffect(function () {
    getStreetView(latitude, longitude, streetViewRef, setShowMap, showFullscreenControl);
  }, [latitude, longitude, showFullscreenControl]);
  return React__default["default"].createElement("div", {
    style: {
      height: height,
      width: width
    },
    ref: streetViewRef,
    className: classes.streetView
  }, ObjectHelper.isPresent(propertyData) && React__default["default"].createElement("div", {
    className: classes.propertyData
  }, React__default["default"].createElement(PropertyDataView, {
    propertyData: propertyData
  })), ObjectHelper.isPresent(zillowData) && React__default["default"].createElement("div", {
    className: classes.propertyData
  }, React__default["default"].createElement(ZillowDataView, {
    zillowData: zillowData
  })), !showMap && !blankData && React__default["default"].createElement("div", {
    className: classes.noStreetView,
    container: true
  }, React__default["default"].createElement(Typography, {
    variant: "body2"
  }, "Street view image not available.")), blankData && React__default["default"].createElement("div", {
    className: classes.blankData,
    container: true
  }, React__default["default"].createElement(Typography, {
    variant: "body2"
  }, "No home preview available.")));
};

GoogleStreetView.defaultProps = {
  zillowData: {},
  propertyData: {},
  height: '100%',
  width: '100%',
  fullscreenControl: false
};
var GoogleStreetView$1 = withGoogleMapsAPI.withGoogleMapsAPI()(withStyles(styles)(GoogleStreetView));

module.exports = GoogleStreetView$1;
